import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M3 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6Zm4 6a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H7.75A.75.75 0 0 1 7 12Zm4 6a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 11 18Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextAlignRightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textAlignRight')) as IconWithRender;

TextAlignRightIcon.displayName = 'TextAlignRightIcon';
TextAlignRightIcon.propTypes = Icon.propTypes;
TextAlignRightIcon.renderIcon = (props) => <TextAlignRightIcon {...props} />;
export default TextAlignRightIcon;
